import { gql } from '@apollo/client';

export const SEARCH_TOOL_CATALOG = gql`
  query SearchToolCatalogs($searchInput: SearchInput) {
    searchToolCatalogs(searchInput: $searchInput) {
      items {
        id
        name
        bscnPartNumber
        isActive
        uomId
        inventoryType
        isLocked
        isFavorite
        limitCount
        toolCatalogImageUrl
        toolCategory {
          id
          name
          toolType {
            id
            name
          }
        }
        uom {
          abbreviation
          id
        }
      }
    }
  }
`;
